/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1BannerBanneridLangsIdMutationResponse,
  DeleteApiV1BannerBanneridLangsIdPathParams,
  DeleteApiV1BannerBanneridLangsId401,
  DeleteApiV1BannerBanneridLangsId404,
  DeleteApiV1BannerBanneridLangsId500,
} from "../../types/bannerIdiomasController/DeleteApiV1BannerBanneridLangsId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1BannerBanneridLangsId } from "../../clients/bannerIdiomasController/deleteApiV1BannerBanneridLangsId.ts";

export const deleteApiV1BannerBanneridLangsIdMutationKey = () =>
  [{ url: "/api/v1/banner/:bannerId/langs/:id" }] as const;

export type DeleteApiV1BannerBanneridLangsIdMutationKey = ReturnType<
  typeof deleteApiV1BannerBanneridLangsIdMutationKey
>;

export function deleteApiV1BannerBanneridLangsIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteApiV1BannerBanneridLangsIdMutationKey();
  return mutationOptions<
    DeleteApiV1BannerBanneridLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1BannerBanneridLangsId401
      | DeleteApiV1BannerBanneridLangsId404
      | DeleteApiV1BannerBanneridLangsId500
    >,
    {
      bannerId: DeleteApiV1BannerBanneridLangsIdPathParams["bannerId"];
      id: DeleteApiV1BannerBanneridLangsIdPathParams["id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ bannerId, id }) => {
      return deleteApiV1BannerBanneridLangsId(bannerId, id, config);
    },
  });
}

/**
 * @description Desativa (exclusão lógica) uma tradução (idioma) de banner. **(Requer Authorization para autenticação)**
 * @summary Excluir idioma do banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:bannerId/langs/:id}
 */
export function useDeleteApiV1BannerBanneridLangsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1BannerBanneridLangsIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1BannerBanneridLangsId401
        | DeleteApiV1BannerBanneridLangsId404
        | DeleteApiV1BannerBanneridLangsId500
      >,
      {
        bannerId: DeleteApiV1BannerBanneridLangsIdPathParams["bannerId"];
        id: DeleteApiV1BannerBanneridLangsIdPathParams["id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiV1BannerBanneridLangsIdMutationKey();

  const baseOptions = deleteApiV1BannerBanneridLangsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1BannerBanneridLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1BannerBanneridLangsId401
      | DeleteApiV1BannerBanneridLangsId404
      | DeleteApiV1BannerBanneridLangsId500
    >,
    {
      bannerId: DeleteApiV1BannerBanneridLangsIdPathParams["bannerId"];
      id: DeleteApiV1BannerBanneridLangsIdPathParams["id"];
    },
    TContext
  >;

  return useMutation<
    DeleteApiV1BannerBanneridLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1BannerBanneridLangsId401
      | DeleteApiV1BannerBanneridLangsId404
      | DeleteApiV1BannerBanneridLangsId500
    >,
    {
      bannerId: DeleteApiV1BannerBanneridLangsIdPathParams["bannerId"];
      id: DeleteApiV1BannerBanneridLangsIdPathParams["id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1BannerBanneridLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1BannerBanneridLangsId401
      | DeleteApiV1BannerBanneridLangsId404
      | DeleteApiV1BannerBanneridLangsId500
    >,
    {
      bannerId: DeleteApiV1BannerBanneridLangsIdPathParams["bannerId"];
      id: DeleteApiV1BannerBanneridLangsIdPathParams["id"];
    },
    TContext
  >;
}
